export default __webpack_public_path__ + "static/media/phone-active.6794c8f2.svg";